export function formatDateRu(value) {
  if (value == null || value === '') return ''
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return String(value)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  return `${day}.${month}.${year}`
}

export function formatDateRuIfDateString(value) {
  const raw = String(value ?? '').trim()
  if (!raw) return ''
  if (/^\d{2}\.\d{2}\.\d{4}$/.test(raw)) return raw
  if (/^[A-Za-z]{3}\s[A-Za-z]{3}\s\d{2}\s\d{4}/.test(raw)) {
    return formatDateRu(raw)
  }
  if (/^\d{4}-\d{2}-\d{2}/.test(raw)) {
    return formatDateRu(raw)
  }
  return raw
}

export default class DateForPicker {
  constructor(date) {
    this.date = date ? new Date(date) : new Date()
  }

  get toISO8601date() {
    return this.date.toISOString().substring(0, 10)
  }

  addDays(daysToAdd) {
    this.date.setDate(this.date.getDate() + daysToAdd)
    return this
  }
}
